import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useForecast } from '../../providers/ForecastProvider';

interface ISelectItem {
  name: string;
  forecastId?: string;
  territoryId?: string;
  forecastCalendarId?: string;
  year?: number;
}

interface INavbarSelect {
  items: ISelectItem[];
  placeholder: string;
  scope: 'territory' | 'forecast' | 'timePeriod';
  setSavedValues: (x: any) => void;
  disabled?: boolean;
}

const CheckModalSelect: React.FC<INavbarSelect> = (props) => {
  const { items, placeholder, scope, setSavedValues, disabled } = props;
  const [selectedItem, setSelectedItem] = useState<string>('');
  const { setForecastId, forecastId, forecastCalendarId, hasForecasts, setForecastCalendarId, setCurrentForecastYear } =
    useForecast();

  useEffect(() => {
    const prevValue = localStorage.getItem(scope) || '';
    const prevYear = localStorage.getItem('curYear');
    if (prevYear) setCurrentForecastYear(Number(prevYear));
    setSelectedItem(prevValue);
    if (scope === 'forecast') setForecastId(prevValue);
    if (scope === 'timePeriod') setForecastCalendarId(prevValue);
    setSavedValues((prevState: any) => {
      const label = scope === 'forecast' ? 'forecastId' : 'forecastCalendarId';
      return { ...prevState, [label]: prevValue };
    });
  }, [forecastId, forecastCalendarId]);

  const handleChange = ({ value }: { value: string }) => {
    const curYear = new Date().getFullYear();
    if (!value) {
      return;
    } else {
      setSelectedItem(value);
      if (scope === 'forecast') {
        setSavedValues((prevState: any) => {
          return { ...prevState, forecastId: value };
        });
      }
      if (scope === 'timePeriod') {
        const currForecastCalendar = items.filter((item) => item.forecastCalendarId === value);
        const yearValue =
          currForecastCalendar && currForecastCalendar[0]?.year ? currForecastCalendar[0].year : curYear;
        setCurrentForecastYear(yearValue);
        localStorage.setItem('curYear', String(yearValue));
        localStorage.setItem('previousCurrentYear', String(yearValue));
        setSavedValues((prevState: any) => {
          return { ...prevState, forecastCalendarId: value };
        });
      }
      localStorage.setItem(scope, value);
      localStorage.setItem(`prev${scope}`, value);
    }
  };

  const options = items?.map((item) => ({
    value: scope === 'forecast' ? item.forecastId : scope === 'territory' ? item.territoryId : item.forecastCalendarId,
    label: item.name,
  }));

  const selectedOption = options?.find((option) => option.value === selectedItem) || null;

  return (
    <div>
      <Select
        isDisabled={!hasForecasts || disabled}
        isSearchable={true}
        value={selectedOption}
        onChange={(option: any) => handleChange(option)}
        placeholder={placeholder}
        options={options}
        styles={{
          container: (baseStyles) => ({
            ...baseStyles,
            width: '180px',
          }),
          control: (baseStyles) => ({
            ...baseStyles,
            minHeight: '27px',
            borderColor: '#e5e5ea',
          }),
          valueContainer: (baseStyles) => ({
            ...baseStyles,
            height: '27px',
            alignItems: 'normal',
          }),
          indicatorsContainer: (baseStyles) => ({
            ...baseStyles,
            height: '27px',
          }),
          menu: (baseStyles) => ({
            ...baseStyles,
            zIndex: 5000,
          }),
        }}
      />
    </div>
  );
};

export default CheckModalSelect;
